import styled from 'styled-components';

export const SelectContainer = styled.div`
  display: flex;
  height: 100%;
`;

export default { SelectContainer };
